import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Button, Divider, Input, message, Popconfirm, Table, Tabs} from 'antd';
// import { Link } from "react-router";
import {
  queryAddressBusinessStatis,
  queryAddressLiberate,
  queryBatchIncuAddress,
  queryDeleteIncuAddress,
  queryIncuAddressList,
  querySaveIncuAddress,
} from '@api/incubator/address';
// import LocalDb from "@util/localDb";
import {BackBtn} from '@comm/BackBtn';
import ModalAdd from './ModalAdd';

const { TabPane } = Tabs;

const status = ['未使用', '已使用'];

class Index extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: [],
      addVisible: false,
      newName: {},
      dataSource: {
        list: [],
        pagination: {},
      },
      statis: {},
    };
  }

  componentDidMount() {
    this.status = '';
    this.current = 1;
    this.getIncuAddressList();
    this.getAddressBusinessStatis();
  }

  getIncuAddressList = () => {
    const { newName } = this.state;
    queryIncuAddressList({
      incubatorUuid: this.props.params.uuid,
      status: this.status,
      ...this.pagination,
    }).then(res => {
      if (res.statusCode === 200) {
        res.data.forEach(item => {
          newName[item.uuid] = item.name;
        });
        this.setState({
          data: res.data,
          dataSource: {
            list: res.data,
            pagination: {
              total: res.totalSize,
              pageSize: 15,
              current: this.current,
            },
          },
        });
      }
    });
  };

  getAddressBusinessStatis = () => {
    queryAddressBusinessStatis({
      incubatorUuid: this.props.params.uuid,
    }).then(res => {
      if (res.statusCode === 200) {
        this.setState({
          statis: res.data,
        });
      }
    });
  };

  deleteIncuAddress = uuid => {
    queryDeleteIncuAddress({ uuid }).then(res => {
      if (res.statusCode === 200) {
        message.success(res.message);
        this.getIncuAddressList();
        this.getAddressBusinessStatis();
      } else {
        message.error(res.message);
      }
    });
  };

  handleAddVisible = flag => {
    this.setState({
      addVisible: !!flag,
    });
  };

  handleAdd = params => {
    queryBatchIncuAddress({
      ...params,
      incubatorUuid: this.props.params.uuid,
    }).then(res => {
      if (res.statusCode === 200) {
        message.success(res.message);
        this.getIncuAddressList();
        this.getAddressBusinessStatis();
        this.handleAddVisible(false);
      } else {
        message.error(res.message);
      }
    });
  };

  handleLiberate = uuid => {
    queryAddressLiberate({ uuid }).then(res => {
      if (res.statusCode === 200) {
        message.success(res.message);
        this.getIncuAddressList();
        this.getAddressBusinessStatis();
      }
    });
  };

  startEdit = uuid => {
    const { data } = this.state;
    data.forEach(item => {
      if (item.uuid === uuid) {
        item.isEdit = !item.isEdit;
      }
    });
    this.setState({
      data,
    });
  };

  submitEdit = uuid => {
    const { newName } = this.state;
    querySaveIncuAddress({
      uuid,
      name: newName[uuid],
    }).then(res => {
      if (res.statusCode === 200) {
        message.success(res.message);
        this.getIncuAddressList();
      } else {
        message.error(res.message);
      }
    });
  };

  handleNameChange = uuid => e => {
    const { newName } = this.state;
    newName[uuid] = e.target.value;
    this.setState({ newName });
  };

  handleTableChange = pagination => {
    this.pagination = {
      limit: pagination.pageSize,
      start: pagination.current,
    };
    this.current = pagination.current;
    this.getIncuAddressList();
  };

  callback = key => {
    this.status = key < 0 ? '' : key;
    this.current = 1;
    this.getIncuAddressList();
  };

  columns = () => {
    const {
      newName,
      dataSource: {
        pagination: { current, total, pageSize },
      },
    } = this.state;
    const { accountInfo } = this.props;
    return [
      {
        title: '编号',
        dataIndex: 'num',
        key: 'num',
        render: (text, record, index) => <span>{total - (current - 1) * pageSize - index}</span>,
      },
      {
        title: '详细地址',
        dataIndex: 'name',
        key: 'name',
        render: (text, record) =>
          record.isEdit ? (
            <Input
              value={newName[record.uuid]}
              onChange={() => this.handleNameChange(record.uuid)}
            />
          ) : (
            <span>{record.name}</span>
          ),
      },
      {
        title: '状态',
        dataIndex: 'status',
        key: 'status',
        render: (text, record) => <span>{status[text]}</span>,
      },
      {
        title: '操作',
        key: 'done',
        render: (rext, record) =>
          !accountInfo.isIncubatorMng ? (
            <span>-</span>
          ) : (
            <span>
              {record.status === 0 ? (
                <span>
                  {record.isEdit ? (
                    <span>
                      <Button
                        style={{ marginRight: '8px' }}
                        onClick={() => this.submitEdit(record.uuid)}
                      >
                        确认
                      </Button>
                      <Button onClick={() => this.startEdit(record.uuid)}>取消</Button>
                    </span>
                  ) : (
                    <Button onClick={() => this.startEdit(record.uuid)}>编辑</Button>
                  )}
                  <span>
                    <Divider type="vertical" />
                    <Popconfirm
                      onConfirm={() => this.deleteIncuAddress(record.uuid)}
                      title="确定删除当前地址吗？"
                      placement="topRight"
                      overlayStyle={{ width: 200 }}
                    >
                      <a className="ant-dropdown-link">删除</a>
                    </Popconfirm>
                  </span>
                </span>
              ) : null}
            </span>
          ),
      },
    ];
  };

  render() {
    const {
      dataSource: { list, pagination },
      addVisible,
      statis,
    } = this.state;
    const { accountInfo } = this.props;
    const ComTable = (
      <Table
        rowKey="uuid"
        style={{ background: '#fff' }}
        rowSelection={{}}
        columns={this.columns()}
        dataSource={list}
        pagination={pagination}
        onChange={this.handleTableChange}
      />
    );
    return (
      <div>
        <div>
          <BackBtn />
        </div>
        <Tabs
          defaultActiveKey="-1"
          onChange={this.callback}
          tabBarExtraContent={
            <div>
              {/* <Link
                to={`/incubator/addressed/${
                  this.props.params.uuid
                }`}
              >
                <Button>地址使用明细</Button>
              </Link> */}
              <Button
                type="primary"
                icon="plus"
                disabled={!accountInfo.isIncubatorMng}
                style={{ margin: '18px 0 15px 8px' }}
                onClick={() => this.handleAddVisible(true)}
              >
                新增地址
              </Button>
            </div>
          }
        >
          <TabPane
            tab={
              <div>
                <div>{statis.sum || 0}</div>
                <div>全部</div>
              </div>
            }
            key="-1"
          >
            {ComTable}
          </TabPane>
          <TabPane
            tab={
              <div>
                <div>{statis.isUsed || 0}</div>
                <div>已使用</div>
              </div>
            }
            key="1"
          >
            {ComTable}
          </TabPane>
          <TabPane
            tab={
              <div>
                <div>{statis.sum && statis.isUsed ? statis.sum - statis.isUsed : 0}</div>
                <div>未使用</div>
              </div>
            }
            key="0"
          >
            {ComTable}
          </TabPane>
        </Tabs>
        {addVisible ? (
          <ModalAdd onCancel={() => this.handleAddVisible(false)} handleAdd={this.handleAdd} />
        ) : null}
      </div>
    );
  }
}

export default connect(state => ({
  accountInfo: state.account_info,
}))(Index);



// WEBPACK FOOTER //
// ./src/components/incubator/address/Index.js